import { Action } from '@ngrx/store';
import { SiteDto } from '@admin/models/site-dto';

export enum SiteActionTypes {
  LoadSites = '[Sites] Load',
  LoadSitesSuccess = '[Sites] Success',
  AddSite = '[Site] Add',
  AddSiteSuccess = '[Site] Add Success',
  GetSite = '[Site] Get',
  GetSiteSuccess = '[Site] Get Success',
  UpdateSite = '[Site] Update',
  UpdateSiteSuccess = '[Site] Update Success',
}

export class LoadSitesSuccess implements Action {
  readonly type = SiteActionTypes.LoadSitesSuccess;

  constructor(public sites: SiteDto[]) {}
}

export class LoadSites implements Action {
  readonly type = SiteActionTypes.LoadSites;
}

export class AddSite implements Action {
  readonly type = SiteActionTypes.AddSite;

  constructor(public site: SiteDto) {}
}

export class AddSiteSuccess implements Action {
  readonly type = SiteActionTypes.AddSiteSuccess;

  constructor(public site: SiteDto) {}
}

export class GetSite implements Action {
  readonly type = SiteActionTypes.GetSite;
  constructor(public siteId: string) {}
}

export class GetSiteSuccess implements Action {
  readonly type = SiteActionTypes.GetSiteSuccess;
  constructor(public site: SiteDto) {}
}

export class UpdateSite implements Action {
  readonly type = SiteActionTypes.UpdateSite;
  constructor(public site: SiteDto) {}
}

export class UpdateSiteSuccess implements Action {
  readonly type = SiteActionTypes.UpdateSiteSuccess;
  constructor(public site: SiteDto) {}
}

export type SiteActions =
  | LoadSites
  | LoadSitesSuccess
  | AddSite
  | AddSiteSuccess
  | GetSite
  | GetSiteSuccess
  | UpdateSite
  | UpdateSiteSuccess;
